<template>

    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
            >
              <v-text-field
                  v-model="item.name"
                  label="Name"
              ></v-text-field>
            </v-col>

             <v-col
                cols="12"
                sm="6"
                md="4"
            >
              <v-text-field
                  v-model="item.key"
                  label="Key"
              ></v-text-field>
            </v-col>
            
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>

</template>

<script>
export default {
  name: "CreateDialog",
  props: {
    formTitle: String,
    item: Object,
    closeFunction: Function,
    saveFunction: Function
  },
  methods: {
    close() {
      this.closeFunction();
    },
    save() {
      this.saveFunction();
    }
  },
  mounted() { }
}
</script>

<style scoped>

</style>